import ScrollCarousel, { measureSlidesPerView } from '../../components/ScrollCarousel';

const SELECTORS = {
  viewport: '[data-article-thumb-carousel-viewport]',
  track: '[data-article-thumb-carousel-track]',
};

const carousels = [];

export default function () {
  document.querySelectorAll('[data-article-thumb-carousel]').forEach((el) => {
    if (el.getAttribute('initialized') === 'true') {
      return;
    }

    const viewport = el.querySelector(SELECTORS.viewport);
    const track = el.querySelector(SELECTORS.track);
    if (!viewport || !track || track.children.length === 0) {
      return;
    }

    el.setAttribute('initialized', 'true');

    // Four thumbs fit per view at desktop widths, narrowing to one on mobile.
    const slides_per_view = measureSlidesPerView(viewport, track.children[0]);

    const carousel = new ScrollCarousel(el, {
      selectors: SELECTORS,
      // Flickity `wrapAround: true`; `contain: true` is handled in SCSS by
      // `scroll-snap-align: start` on the thumbs.
      loop: true,
      prevNextButtons: true,
      pageDots: true,
      draggable: true,
      slidesPerView: slides_per_view,
      // Flickity `groupCells: true` advanced a full viewport at a time.
      slidesPerGroup: slides_per_view,
      ariaLabel: 'Article thumbnails carousel',
    });

    carousels.push(carousel);
  });
}
